document.addEventListener('DOMContentLoaded', function () {
  var productGrid = document.getElementById('ProductGridContainer');

  function getSelectedSize() {
    var urlParams = new URLSearchParams(window.location.search);
    var selected = urlParams.get('filter.v.option.taille') || urlParams.get('filter.v.option.size');
    if (selected) return selected;

    var found = null;
    urlParams.forEach(function (value, key) {
      if (key.toLowerCase() === 'filter.v.option.taille' || key.toLowerCase() === 'filter.v.option.size') {
        found = value;
      }
    });
    return found;
  }

  function filterCards() {
    var selectedSize = getSelectedSize();
    var cards = document.querySelectorAll('.card-wrapper.product-card-wrapper.underline-links-hover[data-sizes]');

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var li = card.closest('li');
      var target = li || card;
      if (!selectedSize) {
        target.style.display = '';
        continue;
      }

      var sizes = (card.getAttribute('data-sizes') || '').split(',');
      target.style.display = sizes.indexOf(selectedSize.trim()) !== -1 ? '' : 'none';
    }
  }

  filterCards();

  if (!productGrid || typeof MutationObserver === 'undefined') return;

  var observer = new MutationObserver(function () {
    filterCards();
  });

  observer.observe(productGrid, {
    childList: true,
    subtree: true,
  });
});
